import { ERRORS } from "../../../../../constants/errors";
import { regex } from "./regex";
import type { Validator } from "./types";

export const zipcode: Validator = ({ name, answer, questionErrorMessage }) => {
  // US ZIP code validation - exactly 5 numeric digits
  const expression = "^[0-9]{5}$";

  return regex({
    name,
    answer,
    validation: {
      type: "regex",
      value: expression,
    },
    questionErrorMessage,
    fallbackMessage: ERRORS.INVALID_ZIPCODE,
  });
};
